<template>
  <v-row>
    <v-col>
      <v-card>
        <v-card-title>Travel & Accommodation Details</v-card-title>
        <v-card-text v-if="registration">
          <p class="mb-3"><strong>{{ registration.miqaatName }}</strong> — Status: {{ formatStatus(registration.status) }}</p>
          <v-row>
            <v-col cols="12" md="6">
              <VueDatePicker v-model="form.arrivalDate" :enable-time-picker="false" auto-apply format="dd/MMM/yyyy" placeholder="Arrival date" />
            </v-col>
            <v-col cols="12" md="6">
              <VueDatePicker v-model="form.departureDate" :enable-time-picker="false" auto-apply format="dd/MMM/yyyy" placeholder="Departure date" />
            </v-col>
          </v-row>
          <div class="text-subtitle-2 mt-3 mb-2">Visa Status</div>
          <v-radio-group v-model="form.hasVisa" inline>
            <v-radio label="Yes" :value="true" />
            <v-radio label="No" :value="false" />
          </v-radio-group>
          <div class="text-subtitle-2 mt-3 mb-2">Accommodation</div>
          <v-radio-group v-model="form.accommodationType">
            <v-radio label="BG" value="BG" />
            <v-radio label="Self" value="Self" />
          </v-radio-group>
          <v-text-field
            v-if="form.accommodationType === 'Self'"
            label="Accommodation Address"
            v-model="form.accommodationAddress"
            class="mb-3"
          />
          <div class="text-subtitle-2 mt-3 mb-2">Flight Booked</div>
          <v-radio-group v-model="form.flightBooked" inline>
            <v-radio label="Yes" :value="true" />
            <v-radio label="No" :value="false" />
          </v-radio-group>
          <template v-if="form.flightBooked">
            <v-text-field label="Carrier" v-model="form.flightCarrier" class="mb-2" />
            <v-text-field label="Flight Number" v-model="form.flightNumber" class="mb-2" />
            <v-row>
              <v-col cols="12" md="6">
                <VueDatePicker v-model="form.flightArrivalDateTime" format="dd/MMM/yyyy HH:mm" placeholder="Flight arrival" />
              </v-col>
              <v-col cols="12" md="6">
                <VueDatePicker v-model="form.flightDepartureDateTime" format="dd/MMM/yyyy HH:mm" placeholder="Flight departure" />
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-text align="end" v-if="registration">
          <v-btn @click="save">Save</v-btn>
        </v-card-text>
      </v-card>

      <MiqaatAdditionalForms
        v-if="registration?.miqaatId"
        class="mt-3"
        :miqaat-id="registration.miqaatId"
      />
    </v-col>
  </v-row>
</template>

<script setup>
import { reactive, ref, inject, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getRegistrationDetail, updateTravelDetails } from "@/services/miqaatService";
import MiqaatAdditionalForms from "./components/MiqaatAdditionalForms.vue";

const route = useRoute();
const loader = inject("loader");
const snackbar = inject("snackBar");

const registration = ref(null);
const form = reactive({
  arrivalDate: null,
  departureDate: null,
  hasVisa: null,
  accommodationType: null,
  accommodationAddress: null,
  flightBooked: null,
  flightCarrier: null,
  flightNumber: null,
  flightArrivalDateTime: null,
  flightDepartureDateTime: null,
});

function formatStatus(status) {
  const map = {
    PendingIncharge: "Pending Incharge",
    PendingCentral: "Pending Central",
    Approved: "Approved",
    Rejected: "Rejected",
  };
  return map[status] || status;
}

async function loadData() {
  loader.show();
  try {
    const data = await getRegistrationDetail(route.params.id);
    registration.value = data;
    Object.assign(form, {
      arrivalDate: data.arrivalDate,
      departureDate: data.departureDate,
      hasVisa: data.hasVisa,
      accommodationType: data.accommodationType,
      accommodationAddress: data.accommodationAddress,
      flightBooked: data.flightBooked,
      flightCarrier: data.flightCarrier,
      flightNumber: data.flightNumber,
      flightArrivalDateTime: data.flightArrivalDateTime,
      flightDepartureDateTime: data.flightDepartureDateTime,
    });
  } catch (error) {
    snackbar.error(error);
  } finally {
    loader.hide();
  }
}

async function save() {
  loader.show();
  try {
    await updateTravelDetails(route.params.id, form);
    snackbar.success("Travel details saved");
    await loadData();
  } catch (error) {
    snackbar.error(error);
  } finally {
    loader.hide();
  }
}

onMounted(loadData);
</script>
